import React, { Component } from "react";
import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom";
import "moment/locale/zh-cn";
import myLoadable from "./myLoadable";

import "./App.css";
import "./App.less";

const OpenDoc = myLoadable({
  loader: () => import("./openDoc/index")
});


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initDone: false,
      locale: "zh",
      protocolUrl: " ",
      privacyUrl: "",
      protocolEngUrl: "",
      privacyEngUrl: "",
      language: "zh-cn"
    };
  }
  componentDidMount() {
  }

  render() {
    // debugger
    return (
      <div className="openweb">
        <div className="app-router-container">
          <Router>
            <Switch>
              <Route path="/help/:id" component={OpenDoc} exact />
              <Redirect from="/" to="/help/93" />
            </Switch>
          </Router>
        </div>
      </div>

    );
  }
}

export default App;
